var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AFRAME } from "../../react/root";
import { createElement } from "../../util";
import mixin from "./mixin";
export default function () {
    AFRAME.registerComponent('checkbox-component', __assign(__assign({ schema: {
            value: { type: 'boolean', default: false },
            label: { type: 'string', default: false },
        }, init: function () {
            this.render();
        }, update: function (oldData) {
            var me = this;
            if (me.button) {
                me.button.setAttribute('value', this.data.label);
                me.button.setAttribute('checked', !!this.data.value);
            }
        }, render: function () {
            var _a;
            var me = this;
            var button = createElement("frame-base-interactive", (_a = {
                    height: .2,
                    margin: '0 0 0 0',
                    value: this.data.label,
                    interactiveType: 'checkbox'
                },
                _a['font-size'] = .07,
                _a))();
            button.setAttribute('resize-on-text', true);
            button.addEventListener('click', function (evt) {
                var _a;
                (_a = me === null || me === void 0 ? void 0 : me.el) === null || _a === void 0 ? void 0 : _a.setAttribute('value', !me.data.value);
                me.el.emit('change', {
                    value: !me.data.value
                });
                me.el.emit('click', {
                    value: !me.data.value
                });
                evt.preventDefault();
            });
            button.addEventListener('size-update', function (evt) {
                me.updateElementSize(me, me.el);
            });
            me.button = button;
            me.el.appendChild(me.button);
            me.updateElementSize(me, me.el);
        } }, mixin), { getWidth: function () {
            var me = this;
            return parseFloat("".concat(me.button.getAttribute('width')));
        }, getHeight: function () {
            var me = this;
            return parseFloat("".concat(me.button.getAttribute('height')));
        } }));
    AFRAME.registerPrimitive('frame-checkbox', {
        defaultComponents: {
            'checkbox-component': {},
        },
        mappings: {
            'label': 'checkbox-component.label',
            'value': 'checkbox-component.value',
        }
    });
}
